<div
  ngbDropdown
  [placement]="'top left'">
  <a
    class="nav-link position-relative"
    id="dropdownBasic3"
    ngbDropdownToggle>
    <i class="ph ph-dots-three"></i>
  </a>
  <div
    ngbDropdownMenu
    aria-labelledby="dropdownBasic3"
    class="text-start">
    <a
      class="dropdown-item p-2 d-flex align-items-center"
      href="javascript:;"
      (click)="logoutClick($event)">
      <i class="ph ph-power me-1"></i>
      <span>{{ 'APPLICATION.NAVBAR.logout' | translate }}</span>
    </a>
  </div>
</div>
